import "../../styles/Faq/faq.css";
import { useState } from "react";
const FAQSection = () => {
  // State to track which question is currently open (null = all closed)
  const [activeId, setActiveId] = useState(null);

  // Toggle function: if clicked ID is already open, close it (set null), else open it
  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  const faqData = [
    {
      id: 1,
      question: "Do you have weekend classes?",
      answer: "Yes, for extra doubt clearing and competitive exam training.",
    },
    {
      id: 2,
      question: "Do you provide online tuition?",
      answer:
        "Yes, we have recorded classes + live Q&A sessions for outstation students.",
    },
  ];

  return (
    <>
      <section className="faq-section py-5">
        <div className="container">
          {/* Title Section with Purple Bar */}
          <div
            className="d-flex align-items-center mb-5"
            style={{ marginLeft: "8%" }}
          >
            <div className="title-bar me-3"></div>
            <h2 className="fw-bold text-dark m-0">
              Frequently Asked Questions
            </h2>
          </div>

          {/* FAQ List */}
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              {faqData.map((item) => (
                <div
                  key={item.id}
                  className={`faq-item mb-3 ${
                    activeId === item.id ? "active" : ""
                  }`}
                  onClick={() => toggleFAQ(item.id)}
                >
                  {/* Question Header */}
                  <div className="faq-header d-flex justify-content-between align-items-center p-3 cursor-pointer">
                    <h6
                      className={`m-0 fw-semibold ${
                        activeId === item.id ? "text-purple" : "text-dark"
                      }`}
                    >
                      {item.question}
                    </h6>
                    <i
                      className={`bi bi-chevron-down transition-icon ${
                        activeId === item.id ? "rotate-180" : ""
                      }`}
                    ></i>
                  </div>

                  {/* Answer Body (Collapsible) */}
                  <div
                    className={`faq-body ${activeId === item.id ? "show" : ""}`}
                  >
                    <div className="p-3 pt-0 text-muted small lh-lg">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us-section position-relative overflow-hidden">
        <div className="container h-100">
          <div className="row h-100 align-items-center">
            {/* Left Column: Text Content */}
            <div className="col-lg-7 py-5 mb-4 mb-lg-0 text-center text-lg-start z-index-2">
              <h2 className="display-4 fw-bold text-dark mb-4 lh-sm">
                From Classrooms to Careers <br />
                We Build Futures.
                <div className="mt-3">
                  {" "}
                  {/* Adds space before the yellow box */}
                  <span className="highlight-box">
                    Learn Today. Lead Tomorrow.
                  </span>
                </div>
              </h2>

              <a
                href="/enroll"
                className="btn btn-black rounded-pill px-4 py-2 fw-semibold mt-2"
              >
                Register Now
              </a>
            </div>
            {/* Right Column: Image */}
            <div className="col-lg-5 text-center position-relative">
              <img
                src="https://madhiacademy.com/wp-content/uploads/2025/08/Asset-025.png"
                alt="Students with laptop and books"
                className="img-fluid position-relative z-index-2 student-img"
              />

              {/* Decorative white doodles (optional CSS implementation) */}
              <div className="doodle-arrow"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQSection;
